export default __webpack_public_path__ + "static/media/gallery_13.f8e1e531.jpg";